export enum errorActionTypes {
  HANDLE_ERROR_FROM_SERVER = "HANDLE_ERROR_FROM_SERVER",
}
